import { render, staticRenderFns } from "./Infographic3.vue?vue&type=template&id=a6228d96&"
import script from "./Infographic3.vue?vue&type=script&lang=js&"
export * from "./Infographic3.vue?vue&type=script&lang=js&"
import style0 from "./Infographic3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports